import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';

import { OrderChatConversationComponent } from './components/order-chat-conversation/order-chat-conversation.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CakeItEasyWebUiModule,
  ],
  declarations: [
    OrderChatConversationComponent,
  ],
  exports: [
    OrderChatConversationComponent,
  ]
})
export class OrderChatModule {
}
